import React, {FC} from 'react'

import { constants as DCConstants } from '../../../DetailsContainer'

import Tags from './Tags'
import Reminders from './Reminders'

import AddTag, { TagAddTrigger } from '../../../TagAdd'
import translate from '../../translator'

import { NotesProps } from '../../types.LoanDetails'

const Notes: FC<NotesProps> = ({ ID, hash, data: { base, reminders, tags, linkedfiles } }) => (
  <div className="u-fluid u-flex">
    <div style={{ flex: 2, display: 'flex' }}>
      <Reminders
        ID={ID}
        hash={hash}
        instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${ID}-Reminders`}
        productType={base.ProductType}
        data={reminders}
        linkedfiles={linkedfiles}
      />
    </div>

    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <div className="u-fluid u-relative">
        <Tags instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${ID}-Tags`} ID={ID} hash={hash} data={tags} />
      </div>

      <div style={{ borderLeft: '1px solid lightgray' }} className="u-padding-5">
        {base.IsArrested !== 1 && <TagAddTrigger permission="LOAN_ADD_TAG">{translate('cmd_add_tag')}</TagAddTrigger>}
        <AddTag type="Loan" addedTags={tags} />
      </div>
    </div>
  </div>
)

export default Notes
